import React from 'react';

import { ApiQueryParams, Month, NumberRange } from '../../../interfaces';
import DatePicker from './DatePicker';
import TravelMonths from './TravelMonths';

//this is a fix for the page jumping when DatePicker gets selected on mobile, REIS-4289
const storePageOffsetY = (): void => {
    if (typeof Storage !== 'undefined' && window.pageYOffset !== 0) {
        window.sessionStorage.setItem('pageOffsetY', window.pageYOffset.toString());
    }
};

export interface TravelTimePickerProps {
    travelMonths: Month[];
    duration?: NumberRange;
    setIgnoredFilters: (filters: string[]) => void;
    triggerFetch: (queryParams?: ApiQueryParams) => void;
    travelMonthsClassName?: string;
    horizontal?: boolean;
}

export const TravelTimePicker: React.FC<TravelTimePickerProps> = ({
    travelMonths,
    duration,
    setIgnoredFilters,
    triggerFetch,
    travelMonthsClassName,
    horizontal = false,
}) => {
    const [flexibleSearch, setFlexibleSearch] = React.useState(travelMonths.length !== 0 || !!duration);

    const pickFixedSearch = (): void => {
        storePageOffsetY();
        setFlexibleSearch(false);
        setIgnoredFilters(['duration', 'travelMonths']);
        triggerFetch();
    };

    const pickFlexibleSearch = (): void => {
        setFlexibleSearch(true);
        setIgnoredFilters(['departureDate', 'returnDate']);
        triggerFetch();
    };

    return (
        <div id="departure-container">
            <div id="departure-type-container" className={`grid${horizontal ? ' u-r-size1of2' : ' u-size1of1'}`}>
                <div className="input input-toggle grid__unit u-size1of2 u-mb4">
                    <input
                        type="radio"
                        id="searchTypeFixed"
                        name="fixed"
                        value="fixed"
                        checked={!flexibleSearch}
                        onClick={(): void => pickFixedSearch()}
                        data-testid="input--travel-time-fixed"
                        readOnly
                    />
                    <label htmlFor="searchTypeFixed" className={`small u-truncate${!flexibleSearch ? ' selected' : ''}`}>
                        Nøyaktig dato
                    </label>
                </div>
                <div className="input input-toggle grid__unit u-size1of2 u-mb4">
                    <input
                        type="radio"
                        id="searchTypeFlexible"
                        name="flexible"
                        value="flexible"
                        checked={flexibleSearch}
                        onClick={(): void => pickFlexibleSearch()}
                        data-testid="input--travel-time-flexible"
                        readOnly
                    />
                    <label htmlFor="searchTypeFlexible" className={`small u-truncate${flexibleSearch ? ' selected' : ''}`}>
                        Ikke bestemt dato
                    </label>
                </div>
            </div>

            {flexibleSearch ? (
                <TravelMonths triggerFetch={triggerFetch} className={travelMonthsClassName} />
            ) : (
                <DatePicker triggerFetch={triggerFetch} horizontal={horizontal} />
            )}
        </div>
    );
};
